export type OperationMailAvailability = {
  /** false ならボタンごと描かない */
  visible: boolean;
  disabled: boolean;
  tooltip: string;
};

type Params = {
  /** license.config.use_driver_app。未取得のあいだは undefined */
  useDriverApp: boolean | undefined;
  selectedShiftTruckCount: number;
};

/**
 * 配車指示メールの可否。
 * V3Plans (presenters/PlanningStatistics.presenter.tsx:285-288) と同じ条件。
 *
 * Why ライセンス無しは「描かない」: 押せないボタンだけ見せても何の機能か分からない。
 * 一方、選択ゼロは「選べば押せる」ので disabled にして理由を出す
 * （自動配車ボタンと同じ 2 段構え）。
 */
export function resolveOperationMailAvailability(
  { useDriverApp, selectedShiftTruckCount }: Params,
): OperationMailAvailability {
  if (!useDriverApp) return { visible: false, disabled: true, tooltip: '' };

  if (selectedShiftTruckCount === 0) {
    return { visible: true, disabled: true, tooltip: '指示メールを送る車両を選択してください' };
  }
  return { visible: true, disabled: false, tooltip: '選択した配車計画の指示メールを送る' };
}
